import React from 'react';
import { Table } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';
import { ImportMember } from 'works/graphql/validate-works-membership-import';

type BadgeProp = { isUpdate: boolean };

function Badge({ isUpdate }: BadgeProp) {
  const backgroundColor = isUpdate
    ? Colors.harvestGoldHyperLight
    : Colors.elmHyperlight;

  return (
    <span
      style={{
        backgroundColor,
        textTransform: 'capitalize',
        borderRadius: '4px',
        padding: '4px',
      }}
    >
      {isUpdate ? 'Update' : 'New'}
    </span>
  );
}

const columns = [
  {
    key: 'firstName',
    dataIndex: 'firstName',
    title: 'First Name',
    className: 'sentry-mask',
  },
  {
    key: 'lastName',
    dataIndex: 'lastName',
    title: 'Last Name',
    className: 'sentry-mask',
  },
  {
    key: 'email',
    dataIndex: 'email',
    title: 'E-mail',
    className: 'sentry-mask',
  },
  {
    key: 'role',
    dataIndex: 'role',
    title: 'Role',
    className: 'members-add-multiple-review-table__role',
    // @TODO: replace this regex by replaceAll native method whenever it is available to this repository
    render: (value: string) => value.replace(/_/g, ' '),
  },
  {
    key: 'employeeId',
    dataIndex: 'employeeId',
    title: 'Employee ID',
    className: 'sentry-mask',
  },
  {
    key: 'phoneNumber',
    dataIndex: 'phoneNumber',
    title: 'Phone Number',
    className: 'sentry-mask',
  },
  {
    key: 'isUpdate',
    dataIndex: 'isUpdate',
    title: 'Add Type',
    render: (value: boolean) => <Badge isUpdate={value} />,
  },
];

type Props = {
  importMembers: ImportMember[];
};

export function MembersAddMultipleReviewTable({ importMembers }: Props) {
  return (
    <>
      <Table
        className="members-add-multiple-review-table"
        columns={columns}
        dataSource={importMembers}
      />
      <style jsx>{`
        :global(.members-add-multiple-review-table .ant-table) {
          padding: 12px;
        }
        :global(.members-add-multiple-review-table .ant-table-tbody > tr > td) {
          padding: 12px 4px 12px 8px;
        }
        :global(.members-add-multiple-review-table__role) {
          text-transform: capitalize;
        }
      `}</style>
    </>
  );
}
